import React from 'react';

export default () => (
<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" width="20" height="20" rx="10" fill="white"/>
<path d="M8.6831 14.5211L16.7958 6.40845L15.5282 5.09859L8.6831 11.9437L5.47183 8.73239L4.20423 10L8.6831 14.5211ZM4.11972 3.66197C5.89437 1.88732 8.02113 1 10.5 1C12.9789 1 15.0915 1.88732 16.838 3.66197C18.6127 5.40845 19.5 7.52113 19.5 10C19.5 12.4789 18.6127 14.6056 16.838 16.3803C15.0915 18.1268 12.9789 19 10.5 19C8.02113 19 5.89437 18.1268 4.11972 16.3803C2.37324 14.6056 1.5 12.4789 1.5 10C1.5 7.52113 2.37324 5.40845 4.11972 3.66197Z" fill="currentColor"/>
</svg>
)
